import { BaseService } from "../../core/baseService";
import {
  SupportServiceInterface,
  SupportRequestParams,
  SupportRequestResponse,
} from "../types/support.types";

export class SupportService
  extends BaseService
  implements SupportServiceInterface
{
  async submitSupportRequest(params: SupportRequestParams) {
    return this.handleRequest<SupportRequestResponse>(
      this.client.post("/api/admin/support/contact", params)
    );
  }
}
